module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avaliacao-header"
  }, [_c('header', {
    staticClass: "header-bar"
  }, [_vm._m(0), _vm._v(" "), (_vm.pessoa.nome) ? _c('div', {
    staticClass: "navigation"
  }, [_c('nav', {
    staticClass: "menu-icons"
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.pessoa.nome))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.pessoa.id))])])]), _vm._v(" "), _c('div', {
    staticClass: "dropmenu-header"
  }, [_c('div', {
    staticClass: "item-icon user"
  }, [_vm._v("\n            " + _vm._s(_vm.pessoa.sigla) + "\n          ")])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('figure', [_c('figcaption', [_vm._v("Avaliação")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://urcamp.edu.br/site/img/logos/logo-branco.png",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-79f3e058!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/avaliacao/components/Header.vue
// module id = 563
// module chunks = 2